
<template>
<section class="content">



  <div class="row loadingContainer" v-if="showLoading">
    <i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw loading"></i>
  </div>

      <!-- /.box-header -->
      <div class="box-body">

        <br>
        <!-- Button trigger modal -->
        <!-- <button type="button" class="btn btn-outline-primary button" data-toggle="modal" data-target="#exampleModalCenter">
          Add Walk-In 
        </button> -->

      <transition name="fade">

        <div class="row loadingContainer" v-if="showPleaseWait">
          <h1>{{alertMessage}}</h1>
        </div>

      </transition>

      </div>


  <div class="row center-block" v-if="showTable">
    <div class="box">
      <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">

        <div class="row box-body">
          
          
          <div class="col-sm-6 table-responsive" id="Feedbacks">

            <table aria-describedby="example1_info" role="grid" id="example" style="width:100%" class="display table table-bordered table-striped dataTable wrap">
              <tbody>

                <tr class="even" role="row">
                  <td class="sorting_1">Selfie Clicked</td>
                  <td class="sorting_1">
                    <p v-if="idCardInfo.customFields.idCardInfo.imageUrl">Yes</p>
                    <p v-if="idCardInfo.customFields.idCardInfo.imageUrl == ''">No</p>
                  </td>
                </tr>

                <tr class="even" role="row">
                  <td class="sorting_1">UID</td>
                  <td class="sorting_1">
                    <!-- {{idCardInfo.customFields.rsvpInfo.uid}} -->
                    <input style="width:100%" type="text" v-model="idCardInfo.customFields.rsvpInfo.uid" disabled="true" class="form-control" id="exampleFormControlInput1" placeholder="">
                  </td>
                </tr>

                <tr class="even" role="row">
                  <td class="sorting_1">Name</td>
                  <td class="sorting_1">
                    <input style="width:100%" type="text" v-model="idCardInfo.customFields.rsvpInfo.name" class="form-control" id="exampleFormControlInput1" placeholder="">
                    <!-- {{idCardInfo.customFields.rsvpInfo.name}} -->
                  </td>
                </tr>

                <tr class="even" role="row">
                  <td class="sorting_1">Mobile</td>
                  <td class="sorting_1">
                    <input style="width:100%" type="text" v-model="idCardInfo.customFields.rsvpInfo.mobile" class="form-control" id="exampleFormControlInput1" placeholder="">
                    <!-- {{idCardInfo.customFields.rsvpInfo.mobile}} -->
                  </td>
                </tr>

                <tr class="even" role="row">
                  <td class="sorting_1">Email</td>
                  <td class="sorting_1">
                    <input style="width:100%" type="text" v-model="idCardInfo.customFields.rsvpInfo.email" class="form-control" id="exampleFormControlInput1" placeholder="">
                    <!-- {{idCardInfo.customFields.rsvpInfo.email}} -->
                  </td>
                </tr>

                <tr class="even" role="row">
                  <td class="sorting_1">DOB</td>
                  <td class="sorting_1">
                    <input style="width:100%" type="text" v-model="idCardInfo.customFields.rsvpInfo.dob" class="form-control" id="exampleFormControlInput1" placeholder="">
                    <!-- {{idCardInfo.customFields.rsvpInfo.dob | Birthdate }} -->
                  </td>
                </tr>

              </tbody>
            </table>

        <div class="btn-group">

          <button type="button" class="btn btn-default" @click="save()">Save</button>
          <button type="button" class="btn btn-default" @click="generateIdCard()">Generate ID Card</button>
          <button type="button" class="btn btn-default" @click="sendIDCardPrompt()">Send ID Card</button>
        
        </div>


          </div>




          <div class="col-sm-6" id="Feedbacks">

            <img :src="idCardInfo.customFields.idCardInfo.idCardUrl" style="width: 30%;"/>

          </div>


          
        </div>


        
      </div>
      <!-- /.box-body -->
    </div>


  </div>
  </div>
</section>
</template>

<script>

import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import Autocomplete from 'vuejs-auto-complete'
import {
  globalStore
} from '../../main.js';

// Require needed datatables modules
require('datatables.net')
require('datatables.net-bs')

export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      rsvpId: "",
      idCardInfo: {},
      FormInfo: {},
      adminInfo: {},
      clientId: globalStore.clientId,
      employeeId: localStorage.getItem('employeeId'),
      url: globalStore.url,
      token: localStorage.getItem('token'),
      table: '',
      List: [],
      showLoading: true,
      showPleaseWait: false,
      showTable: false,
    }
  },
  created() {
    
    console.log("Created");

    // Access the query param from the URL
    this.rsvpId = this.$route.query.rsvpId;
    console.log(this.rsvpId); // Do something with the rsvpId


  },
  mounted() {

    console.log("Mounted");
    this.getRsvpInfo();
    this.getParams();


  },
  methods: {
    getRsvpInfo(){

      console.log("Get RSVP Info for: "+this.rsvpId);

      // const config = {
      //   headers:{
      //     Authorization: globalStore.token,
      //   }
      // };

      axios.get(
        globalStore.url+ `/api/get-one-rsvp/`+this.rsvpId
        ).then(response => {
          console.log("Get rsvpInfo API Response");

          console.log(response)

          this.idCardInfo = response.data[0];

          this.showLoading = false;
          this.showTable = true;

        }).catch(e => {
          alert(e);
          console.log("Error :"+JSON.stringify(e));
        });

    },
    save(){

      this.alertMessage = "Please wait...";
      this.showPleaseWait = true;

      console.log("Save Clicked");
      console.log(this.idCardInfo.customFields.rsvpInfo);

      var payload = {};
      payload.rsvpId = this.idCardInfo._id;
      payload.rsvpInfo = this.idCardInfo.customFields.rsvpInfo;

      console.log("rsvpId: "+payload.rsvpId);

      axios.put(
            globalStore.url+ `/api/update-rsvpinfo`,payload
            ).then(response => {
              console.log("Update rsvpInfo API Response");

              console.log(response)

              this.getRsvpInfo();

              this.alertMessage = "Saved Successfully."

              setTimeout(() => {
                
                this.showPleaseWait = false;

              }, 3000);


              // location.reload();

            }).catch(e => {
              alert(e);
              console.log("Error :"+JSON.stringify(e));
            });


    },
    generateIdCard(){

      this.alertMessage = "Generating ID Card. This will take a while. Please wait...";
      this.showPleaseWait = true;

      console.log("Generate ID Card Clicked.");
      console.log(this.idCardInfo.customFields.rsvpInfo);

      // imgUrl: req.body.imgUrl,
      //     name: req.body.name,
      //     uid: req.body.uid,
      //     mobile: req.body.mobile,
      //     email: req.body.email,
      //     dob: req.body.dob,

      var payload = {};
      payload.rsvpId = this.idCardInfo._id;
      payload.imgUrl = this.idCardInfo.customFields.idCardInfo.imageUrl;
      payload.name = this.idCardInfo.customFields.rsvpInfo.name;
      payload.uid = this.idCardInfo.customFields.rsvpInfo.uid;
      payload.mobile = this.idCardInfo.customFields.rsvpInfo.mobile;
      payload.email = this.idCardInfo.customFields.rsvpInfo.email;
      payload.dob = this.idCardInfo.customFields.rsvpInfo.dob;

      console.log("rsvpId: "+payload.rsvpId);


      axios.put(
            globalStore.url+ `/api/generate-idcard-cyl`,payload
            ).then(response => {
              console.log("Update rsvpInfo API Response");

              console.log(response)

              this.getRsvpInfo();

              this.alertMessage = "ID Card Generated Successfully."

              setTimeout(() => {
                
                this.showPleaseWait = false;

              }, 3000);


              // location.reload();

            }).catch(e => {
              alert(e);
              console.log("Error :"+JSON.stringify(e));
            });


    },
    sendIDCardPrompt(){

                  const Swal = require('sweetalert2')        

                  console.log(this.idCardInfo.customFields.rsvpInfo.mobile);

                  Swal.fire({
                  title: 'Enter Mobile to Send ID Card',
                  input: 'text',
                  inputAttributes: {
                    autocapitalize: 'off'
                  },
                  inputValue: this.idCardInfo.customFields.rsvpInfo.mobile,
                  showCancelButton: true,
                  confirmButtonText: 'Send Whatsapp',
                  showLoaderOnConfirm: true,
                  preConfirm: (mobile) => {

                    // Handle the input value here
                    // For example, you can save it to data property or send to server
                    console.log("User input:", mobile);


                    console.log("New Mobile: "+mobile);

                    const Swal = require('sweetalert2')        

                    this.sendWhatsappIDCard(mobile);

                  },
                  allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Handle the confirmation here
                  }
                })      

    },
    sendWhatsappIDCard(mobile){

            console.log("Send ID Card via Whatsapp");

            console.log("New Mobile: "+mobile);

            const url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + mobile;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                     Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
                },
                data: JSON.stringify({
                    broadcast_name: 'cyl_send_idcard_admin_panel',
                    parameters: [
                        { name: 'name', value: this.idCardInfo.customFields.rsvpInfo.name },
                        { name: 'idcard_url', value: this.idCardInfo.customFields.idCardInfo.idCardUrl }
                    ],
                    template_name: 'cyl_id_card'
                })
            };
            
            axios(url, options)
                .then(response => {
                    return response.data; // Assuming you want to do something with the data
                })
                .then(data => {
                    // You can handle the data here if needed
                    console.log("-- Data Processed --");

                    Swal.fire({
                        title: 'Success!',
                        text: 'Whatsapp has been sent successfully.',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                      });                

                })
                .catch(error => {
                    console.log("------- ERROR -------");
                    console.error('error:' + error);
                    console.log("--- xxx ---");

                    const Swal = require('sweetalert2')
                      Swal.fire({
                        title: 'Sorry!',
                        // html:'<h2>'+info.status+'</h2>',
                        html:'Something went wrong. Please try again.',
                        type: 'error',
                        showConfirmButton: false,
                        // timer: 1500
                      })                    

                });      

    },
    getParams(){

      console.log("Get All Params");

      axios.get(
        globalStore.url+ `/api/get-all-params`
        ).then(response => {
          console.log("Get All Params API Response");

          console.log(response)

          console.log("Available UID: "+response.data[0].customFields.cyl_counter);




        }).catch(e => {
          alert(e);
          console.log("Error :"+JSON.stringify(e));
        });

    }
  }
}
</script>

<style scoped>
/* .btn-warning,
.btn-danger {
  width: 5em;
} */

h3{
  color: #000000;
}

.btn{
  width: 150px;
  margin-right: 10px;;
}


</style>



// WEBPACK FOOTER //
// EditIDCard.vue?993f751c